import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGridField, InlineGrid } from '@components/form';
import { RepairsHistoriesDetailForm } from '@modules/repairs/RepairsHistoriesDetailForm';
import { repairsHistoriesColumns } from '@modules/repairs/_repairsColumns';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={12}>
          <Row>
            <Col md={12}>
              <InlineGridField
                component={InlineGrid}
                name="histories"
                Form={RepairsHistoriesDetailForm}
                columns={repairsHistoriesColumns}
                showCheckboxes={false}
                deleting={false}
                adding={false}
                filtering={false}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);
export const RepairsHistoriesForm = View;



// WEBPACK FOOTER //
// ./src/modules/repairs/RepairsHistoriesForm.tsx